export default "__VITE_ASSET__DduHI2ZA__"